import dayjs from "dayjs";
import "dayjs/locale/es";
import { IonIcon } from "@ionic/react";
import React from "react";
import { homeOutline } from "ionicons/icons";
import {
  printOutline,
  calendarOutline,
  medicalOutline,
  checkmarkCircleOutline,
  closeCircleOutline,
  hourglass,
  filterOutline,
  addCircleOutline,
} from "ionicons/icons";

import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import ModernDesplegable from "../../components/basicsComponents/ModernDesplegable/ModernDesplegable";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import { Typography } from "@mui/joy";
import { useTurnosPaciente } from "./useTurnosPaciente";
import "./TurnosPaciente.css";

export default function TurnosPaciente() {
  // Estado para abrir/cerrar el filtro de especialidad y prestador
  const [openEspecialidad, setOpenEspecialidad] = React.useState(false);
  const [openPrestador, setOpenPrestador] = React.useState(false);
  const [especialidadFiltro, setEspecialidadFiltro] = React.useState(-1);
  const [prestadorFiltro, setPrestadorFiltro] = React.useState(-1);
  const {
    usuario,
    cargando,
    listadoTurnos,
    listadoTurnosFiltrados,
    turnoSeleccionado,
    abrirModalCancelarReserva,
    abrirComprobanteTurno,
    setAbrirModalCancelarReserva,
    handleClickSeleccionarTurno,
    handleClickCancelarReserva,
    handleClickComprobanteTurno,
    handleClickReservarTurnoPrestador,
    toggleComprobanteTurno,
  } = useTurnosPaciente();

  const {
    formatearFechaTurno,
    obtenerEstadoTurno,
  } = require("./turnosPacienteUtils");

  const getEstadoConfig = (estado) => {
    const configs = {
      Confirmado: {
        icon: checkmarkCircleOutline,
        class: "confirmado",
        color: "#43e97b",
      },
      Pendiente: {
        icon: hourglass,
        class: "pendiente",
        color: "#ffc409",
      },
      Cancelado: {
        icon: closeCircleOutline,
        class: "cancelado",
        color: "#ff6b6b",
      },
      Asistido: {
        icon: checkmarkCircleOutline,
        class: "asistido",
        color: "#5153B3",
      },
    };
    return configs[estado] || configs["Pendiente"];
  };
  const turnosFiltrados = React.useMemo(() => {
    let filtrados = listadoTurnosFiltrados;
    if (especialidadFiltro !== -1) {
      filtrados = filtrados.filter(
        (t) => t.especialidad === especialidadFiltro,
      );
    }
    if (prestadorFiltro !== -1) {
      filtrados = filtrados.filter((t) => t.prestadorCod === prestadorFiltro);
    }
    return filtrados;
  }, [listadoTurnosFiltrados, especialidadFiltro, prestadorFiltro]);
  const renderTurnosModernos = () => (
    <div className="tech-turnos-lista">
      {turnosFiltrados &&
        Array.isArray(turnosFiltrados) &&
        turnosFiltrados.map((turno) => {
          const estado = obtenerEstadoTurno(turno);
          const estadoConfig = getEstadoConfig(estado);

          return (
            <div
              key={turno.codigo}
              className="tech-turno-card"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <div style={{ flex: 1.95, minWidth: 0 }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "1.02rem",
                    lineHeight: 1.22,
                    color: "#1a2a3a",
                    marginBottom: 2,
                  }}
                >
                  {turno.prestadorNom}{" "}
                  {turno.especialidadNom ? `- ${turno.especialidadNom}` : ""}
                </div>
                <div
                  style={{
                    fontSize: "0.91rem",
                    lineHeight: 1.25,
                    color: "#222",
                    marginBottom: 0,
                  }}
                >
                  <span style={{ fontSize: "1.2rem" }}>📅</span>{" "}
                  {formatearFechaTurno(turno.fecha, turno.hora)}
                </div>
              </div>

              <div
                style={{
                  flex: 0.9,
                  minWidth: 0,
                  textAlign: "center",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                }}
              >
                {turno.mutualNom && (
                  <div
                    style={{
                      fontSize: "0.84rem",
                      lineHeight: 1.2,
                      color: "#4a4a4a",
                      marginBottom: 1,
                    }}
                  >
                    {turno.mutualNom}
                  </div>
                )}
                <div
                  style={{
                    fontSize: "0.86rem",
                    lineHeight: 1.2,
                    color: "#4a4a4a",
                    marginBottom: 0,
                  }}
                >
                  Estado:
                  {estado === "Cancelado" ? (
                    <span
                      style={{
                        display: "inline-block",
                        background:
                          "linear-gradient(90deg, #ffb86b 0%, #ff6b6b 100%)",
                        color: "#fff",
                        fontWeight: 700,
                        borderRadius: "16px",
                        padding: "3px 14px",
                        marginLeft: "6px",
                        fontSize: "0.8rem",
                        boxShadow: "0 2px 8px rgba(255,107,107,0.10)",
                      }}
                    >
                      {estado}
                    </span>
                  ) : estado === "Asistido" ? (
                    <span
                      style={{
                        display: "inline-block",
                        background:
                          "linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)",
                        color: "#fff",
                        fontWeight: 700,
                        borderRadius: "16px",
                        padding: "3px 14px",
                        marginLeft: "6px",
                        fontSize: "0.8rem",
                        boxShadow: "0 2px 8px rgba(67,233,123,0.10)",
                      }}
                    >
                      {estado}
                    </span>
                  ) : estado === "Pendiente" ? (
                    <span
                      style={{
                        display: "inline-block",
                        background:
                          "linear-gradient(90deg, #C4C5E8 0%, #5153B3 100%)",
                        color: "#222",
                        fontWeight: 700,
                        borderRadius: "16px",
                        padding: "3px 14px",
                        marginLeft: "6px",
                        fontSize: "0.8rem",
                        boxShadow: "0 2px 8px rgba(58, 61, 153, 0.10)",
                      }}
                    >
                      {estado}
                    </span>
                  ) : (
                    <span style={{ fontWeight: 600, marginLeft: "8px" }}>
                      {estado}
                    </span>
                  )}
                </div>
              </div>

              {/* Columna 3: Acciones */}
              <div
                style={{
                  flex: 0.88,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "6px",
                }}
              >
                <button
                  className="tech-action-btn comprobante"
                  onClick={() => handleClickComprobanteTurno(turno)}
                >
                  <IonIcon icon={printOutline} />
                  <span>Comprobante</span>
                </button>
                <button
                  className="tech-action-btn reservar"
                  onClick={() =>
                    handleClickReservarTurnoPrestador(turno.prestadorCod)
                  }
                >
                  <IonIcon icon={addCircleOutline} />
                  <span>Reservar Turno</span>
                </button>
                {(estado === "Confirmado" || estado === "Pendiente") && (
                  <button
                    className="tech-action-btn danger"
                    onClick={() => handleClickSeleccionarTurno(turno)}
                  >
                    <IonIcon icon={closeCircleOutline} />
                    <span>Cancelar</span>
                  </button>
                )}
              </div>
            </div>
          );
        })}

      {(!turnosFiltrados ||
        !Array.isArray(turnosFiltrados) ||
        turnosFiltrados.length === 0) && (
        <div className="tech-empty-state">
          <div className="tech-empty-icon">
            <IonIcon icon={calendarOutline} />
          </div>
          <Typography className="tech-empty-title">
            No tienes turnos programados
          </Typography>
          <Typography className="tech-empty-subtitle">
            Cuando reserves un turno, aparecerá aquí para que puedas
            gestionarlo.
          </Typography>
        </div>
      )}
    </div>
  );

  const handleVolverInicio = () => {
    window.location.href = "/portal/Inicio";
  };

  return (
    <div className="tech-turnos-container">
      {cargando && <LoadingBackdrop visualizar={cargando} />}

      <div className="tech-turnos-header">
        <div
          className="turnos-header-row"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: window.innerWidth < 768 ? "stretch" : "center",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            gap: "12px",
          }}
        >
          <h1
            className="tech-page-title"
            style={{
              fontSize: window.innerWidth < 768 ? "1.24rem" : "1.36rem",
              lineHeight: 1.1,
              marginBottom: 0,
            }}
          >
            Resumen de Mis Turnos
          </h1>
          <button
            className="tech-action-btn volver-inicio"
            onClick={handleVolverInicio}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "12px 20px",
              backgroundColor: "white",
              border: "2px solid #1976f3",
              borderRadius: "12px",
              color: "#1976f3",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(58, 61, 153, 0.10)",
              alignSelf: window.innerWidth < 768 ? "flex-start" : "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#3A3D99";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(58, 61, 153, 0.18)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.color = "#3A3D99";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 2px 8px rgba(58, 61, 153, 0.10)";
            }}
          >
            <IonIcon icon={homeOutline} style={{ fontSize: "18px" }} />
            <span>Volver al inicio</span>
          </button>
        </div>
      </div>

      {listadoTurnos === null || listadoTurnos.length <= 0 ? (
        <div className="tech-empty-state">
          <div className="empty-icon">
            <IonIcon icon={medicalOutline} />
          </div>
          <h3>No tienes turnos registrados</h3>
          <p>Cuando tengas turnos programados, aparecerán aquí</p>
          <button
            className="tech-action-btn primary"
            onClick={() => {
              /* Navigate to new appointment */
            }}
          >
            <IonIcon icon={addCircleOutline} />
            <span>Solicitar Turno</span>
          </button>
        </div>
      ) : (
        <>
          {/* Filtros modernos */}
          <div className="tech-filtros-container" style={{ display: "none" }}>
            <div className="tech-filtros-header">
              <h2 className="tech-page-title secondary">
                <IonIcon
                  icon={filterOutline}
                  className="filter-icon"
                  style={{ color: "#1976f3" }}
                />
                <span style={{ color: "#1976f3" }}>
                  Aquí puedes filtrar y buscar entre tus turnos
                </span>
              </h2>
            </div>

            <div className="tech-filtros-grid">
              <div
                className="tech-filtros-row"
                style={{ display: "flex", gap: "16px", alignItems: "flex-end" }}
              >
                <div className="tech-filter-group glass-filter">
                  <ModernDesplegable
                    array={(() => {
                      const especialidadesTurnos = listadoTurnosFiltrados
                        .map((t) => ({
                          codigo: t.especialidad,
                          text: t.especialidadNom,
                        }))
                        .filter(
                          (e) => e.codigo !== undefined && e.text !== undefined,
                        );
                      const mapa = new Map();
                      especialidadesTurnos.forEach((e) => {
                        if (!mapa.has(e.codigo)) mapa.set(e.codigo, e.text);
                      });
                      const lista = Array.from(mapa.entries()).map(
                        ([codigo, text]) => ({ codigo, text }),
                      );
                      return [{ codigo: -1, text: "Mostrar todos" }, ...lista];
                    })()}
                    placeholder={"Seleccione especialidad"}
                    value={especialidadFiltro}
                    handleChange={(value) => {
                      setEspecialidadFiltro(value);
                      setOpenEspecialidad(false);
                    }}
                    label="Especialidad"
                    id="especialidad"
                    isOpen={openEspecialidad}
                    setIsOpen={setOpenEspecialidad}
                    emoji="🏥"
                    color="#3A3D99"
                  />
                </div>
                <div className="tech-filter-group glass-filter">
                  <ModernDesplegable
                    array={(() => {
                      const prestadoresTurnos = listadoTurnos
                        .map((t) => ({
                          codigo: t.prestadorCod,
                          text: t.prestadorNom,
                        }))
                        .filter(
                          (e) =>
                            e.codigo !== undefined &&
                            e.text !== undefined &&
                            e.text !== null,
                        );
                      const mapa = new Map();
                      prestadoresTurnos.forEach((e) => {
                        if (e.codigo !== null && !mapa.has(e.codigo))
                          mapa.set(e.codigo, e.text);
                      });
                      const lista = Array.from(mapa.entries()).map(
                        ([codigo, text]) => ({ codigo, text }),
                      );
                      return [{ codigo: -1, text: "Mostrar todos" }, ...lista];
                    })()}
                    placeholder={"Seleccione prestador"}
                    value={prestadorFiltro}
                    handleChange={(value) => {
                      setPrestadorFiltro(value);
                      setOpenPrestador(false);
                    }}
                    label="Prestador"
                    id="prestador"
                    isOpen={openPrestador}
                    setIsOpen={setOpenPrestador}
                    emoji="👨‍⚕️"
                    color="#764ba2"
                  />
                </div>
              </div>
            </div>
            <br />
            <br />
            <div className="tech-filtros-adicionales"></div>
          </div>
          {renderTurnosModernos()}

          <DialogoConfirmacion
            titulo="Cancelar turno"
            texto={`Ha decidido cancelar el turno con el/la profesional ${
              turnoSeleccionado?.prestadorNom || ""
            }, con especialidad en ${
              turnoSeleccionado?.especialidadNom || ""
            }, para el día ${obtenerNombreDia(
              dayjs().format("dddd"),
            )} ${dayjs().format("DD")} de ${dayjs().format(
              "MMMM, YYYY",
            )} a las ${dayjs().format("HH:mm")}, ¿Esta seguro/a de ello?`}
            open={abrirModalCancelarReserva}
            setOpen={setAbrirModalCancelarReserva}
            handleClickConfirmar={handleClickCancelarReserva}
            colorBotonNo="danger"
            colorBotonSi="success"
            textoBotonNo="No"
            textoBotonSi="Si, cancelo"
          />

          <ComprobanteTurno
            turno={turnoSeleccionado}
            abrir={abrirComprobanteTurno}
            togleAbrirCerrarComprobanteTurno={toggleComprobanteTurno}
            paciente={usuario}
          />

          <CustomToast
            openToast={false}
            onDidDismiss={() => {}}
            message={""}
            colorNotificacion={""}
          />
        </>
      )}
    </div>
  );
}
